module.exports = __webpack_public_path__ + "fonts/intelo-regular.cb2f84a.woff";